import "../Css/home.css";
import Counter from "../components/Counter";
import Headings from "../components/Headings";
import Image from "../components/Image";
import ParaCards from "../components/ParaCards";
import resume from "../images/Azhar-resume.pdf";
import aboutimg from "../images/aboutImg.jpg";

import { aboutCards, counter, imges, navbar } from "../json/data";

export default function About() {
  return (
    <>
      <div className="About">
        {imges.slice(1, 2).map((pic, i) => {
          return <Image key={i} pictures={pic.img} />;
        })}
        <div className="Right-About">
          {navbar.slice(0, 1).map((data, index) => {
            return (
              <Headings
                key={index}
                topDiscription={data.name}
                heading={data.heading}
              />
            );
          })}
          <div className="About-content">
            <div className="small-img">
              <img
                src={aboutimg}
                alt=" Capture Abu Azhar's dynamic expertise and commitment to seamless web design."
              />
            </div>
            <div className="heading-cards">
              <div className="para">
                <h2>I'M ABU AZHAR</h2>
                <p>
                  Dynamic Frontend Developer with a Computer Science degree,
                  skilled in{" "}
                  <strong>HTML, CSS, JavaScript, Bootstrap, ReactJS </strong>{" "}
                  and <strong>TailwindCSS</strong>. Passionate about{" "}
                  <strong>user-friendly web experiences</strong> and innovative
                  problem-solving. Eager to cont ribute and grow in frontend
                  development.Possesses <strong>hands-on experience</strong> in
                  website development projects, showcasing a strong foundation
                  in creating responsive and visually appealing interfaces.
                </p>
              </div>
              <div className="cards">
                {aboutCards.map((item, index) => {
                  return (
                    <ParaCards
                      key={index}
                      heading={item.heading}
                      para={item.paragraph}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="CV-bttn">
            <hr />
            <a href={resume} download="Resume">
              <button>DOWNLOAD CV</button>
            </a>
          </div>
          <div className="counter-works">
            {counter.map((count, i) => {
              return (
                <Counter key={i} num={count.number} head={count.discription} />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
